import { useQuery } from "@tanstack/react-query"
import { routes } from "@nova-ai/shared"
import type { ProductValuesDetail } from "@nova-ai/product-detail-contract"

import { apiFetch } from "../lib/api"
import { queryKeys } from "./query-keys"

export function useProductValues(
  configSku: string,
  marketplace: string | undefined,
  enabled = true
) {
  return useQuery({
    queryKey: queryKeys.productValues(configSku, marketplace),
    enabled: enabled && configSku.length > 0,
    queryFn: async () => {
      const result = await apiFetch<ProductValuesDetail>(
        routes.products.values({ sku: configSku }),
        {
          ...(marketplace !== undefined ? { query: { marketplace } } : {}),
        }
      )
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return result.value
    },
  })
}
